import request from '@/plugins/request';

export function tree() {
    return request({
        url: '/store/category/tree',
        method: 'get',
    });
}

/**
 * 平台分类
 */
export function goods() {
    return request({
        url: '/store/category/goods',
        method: 'get',
    });
}

export function list (data) {
    return request({
        url: '/store/category/list',
        method: 'post',
        data
    });
}

export function add (data) {
    return request({
        url: '/store/category/add',
        method: 'post',
        data
    });
}

export function edit (data) {
    return request({
        url: '/store/category/edit',
        method: 'post',
        data
    });
}

export function del (data) {
    return request({
        url: '/store/category/delete',
        method: 'post',
        data
    });
}
